import { render, staticRenderFns } from "./SalesChannels.vue?vue&type=template&id=583bd281&scoped=true&"
import script from "./SalesChannels.vue?vue&type=script&lang=js&"
export * from "./SalesChannels.vue?vue&type=script&lang=js&"
import style0 from "./SalesChannels.vue?vue&type=style&index=0&id=583bd281&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583bd281",
  null
  
)

export default component.exports